import React from 'react';
import {CheckboxInfo, CheckBoxRow, CheckBoxSizer, CheckboxSubtitle, CheckboxTitle} from '../TimeManagement_styled';
import {BetaTag, Checkbox} from '@/web-components';
import {FlexRow} from '@forecast-it/design-system';

type TimeRegistrationSettingProps = {
	checked: boolean;
	cy: string;
	callback: () => void;
	title: string;
	subtitle: string;
	isBeta?: boolean;
};

function TimeRegistrationSetting({
	title,
	subtitle,
	checked,
	cy,
	callback,
	isBeta = false,
}: TimeRegistrationSettingProps): React.JSX.Element {
	return (
		<CheckBoxRow>
			<CheckBoxSizer>
				<Checkbox checked={checked} cy={cy} onClick={callback} />
			</CheckBoxSizer>
			<CheckboxInfo>
				<FlexRow>
					<CheckboxTitle>{title}</CheckboxTitle>
					{isBeta && <BetaTag />}
				</FlexRow>
				<CheckboxSubtitle>{subtitle}</CheckboxSubtitle>
			</CheckboxInfo>
		</CheckBoxRow>
	);
}

export default TimeRegistrationSetting;
